module.exports = {
    home: {
        'tab1': '常用食材',
        'tab2': 'TOP榜',
        'tab3': '名厨菜谱',
        'tab4': '推荐',
        'msg1': '住家饭由新鲜食材+智能烹饪机现场制作',
        'more': '更多体验店'
    },
    tips: {
        'no_data': '没有数据',
        'loading': '加载中',
        'shareMsg': '请点击右上角，使用浏览器打开',
        'searchMsg': '输入门店或者地址关键字',
        'keywords': '关键词',
        'data': '数据',
        'jie': '结',
        'long': '没有更多的数据了',
        'delete': '确定要删除吗？',
        'noSearch': '没有搜索结果',
        'no': '暂无',
        'collect': '确定要取消收藏吗？',
        'confirm': '确认',
        'confirm1': '确定',
        'connect': '联系',
        'detail': '明细',
        'oneMore': '再来一单'
    },
    shop: {
        'settlement': '去结算',
        'sendPay': '配送费',
        'short': '还差',
        'send1': '送货到家',
        'send2': '到店自取',
        'isReady':'已经准备好了，请到门店自取',
        'msg1': '选择本服务则默认阅读并同意',
        'msg2': '用户到店自取授权协议',
        'packet': '红包',
        'coupon': '优惠券',
        'chose': '选择',
        'getPacket': '去领红包',
        'getCoupon': '去领优惠券',
        'shopCoupon': '店铺优惠券',
        'title1': '优惠卡包',
        'getPack': '领红包',
        'getCoup': '领优惠券',
        'businessHours': '营业时间',
        'msg3': '请在营业时间内到店自取，不提供隔天取货服务',
        'store': '店铺',
        'msg4': '本单将由以下店铺负责配送',
        'storeName': '店铺名称',
        'msg5': '店铺已暂停营业',
        'welcome': '欢迎',
        'pleaceChose': '请选择',
        'sendTime': '送达时间',
        'expect': '预计',
        'time': '时间',
        'orderTime': '下单时间',
        'phone': '预留电话',
        'msg6': '选择地址后使用优惠券',
        'msg7': '选择地址后使用红包',
        'msg8': '现时间晚于自取可选时间，无法到店自取',
        'msg9': '请输入正确的手机号',
        'msg10': '距离自取时间小于10分钟，请重新选择时间',
        'msg11': '请选择收货地址',
        'msg12': '请选择送达时间',
        'noCoupon': '暂无优惠券可用',
        'noPacket': '暂无红包可用',
        'zhang': '张',
        'ge': '个',
        'total': '总计', 
        'man': '满',
        'fare': '运费',
        'hu': '户',
        'preferential': '购买优惠',
        'realAmount': '实付',
        'order': '订单',
        'ma': '吗',
        'confirm': '确定',
        'nowGo': '立即抢购',
        'hou': '后',
        'orgTel': '联系电话',
        'choseShop': '选择自取门店',
        'selfTakeTime':'选择自取时间',
        'canceMsg':'很抱歉，由于库存不足，该订单已被商家取消！',
        'backMag':'款项已退回到我的',
        'failFeeback':'退款失败，请与商家联系',
        'orderType':'净菜',
        'tastyFood':'美食',
        'readying':'准备',
      'noSelfTake':'该店不支持到店自取，请选择送货到家',
      'selectSelfTakeTime':'请选择自取时间',
      'selectSendToTime':'请选择送达时间'
    },
    detail: {
        'chef': '名厨',
        'intro': '名厨介绍',
        'title': '烹饪机设备专用',
        'num': '菜谱编号',
        'place': '产地',
        'expiration': '保质期',
        'spec': '规格',
        'cooking_time': '烹饪时间',
        'storage': '存储条件',
        'cooking_steps': '烹饪步骤',
        'step1': '一键烹饪',
        'step2': '分段烹饪',
        'hour': '小时',
        'second': '秒',
        'minute': '分钟'
    },
    menu: {
        'menu': '菜谱',
        'bind': '绑定设备',
        'buy': '购买',
        'cook': '烹饪',
        'num': '编号',
        'tip': '即将同步以下菜谱到烹饪机设备上',
        'meal': '餐单',
        'clear': '确定要清空菜篮吗',
        'same': '即将同步餐单菜谱到烹饪机设备上',
        'first': '请先绑定设备',
        'foodsNum': '菜谱名字/编号'
    },
    order: {
        'total': '原价总计金额',
        'connect': '联系商家',
        'send': '送达',
        'get': '收货',
        'quhuo': '取货',
        'num': '订单号',
        'detail': '订单明细',
        'msg1': '感谢您对我们的信任',
        'msg2': '请耐心等候商家发货',
        'msg3': '我们正在路上，很快就能送达',
        'msg4': '期待再次光临',
        'msg5': '感谢你的信任，是否确认收货',
        'start': '出发时间',
        'msg6': '等待商家发货中...',
        'over': '超时',
        'bad': '过期',
        'tab1': '待发货',
        'tab2': '待确认',
        'cardCenter': '领取中心',
        'getTime': '领取时间',
        'lingqu': '领取',
        'yue': '粮票明细',
        'yue1': '粮票',
        'zhanghu': '账户',
        'balance': '累计积分',
        'dian': '点',
        'phone': '电话',
        'onlineRecharge':'在线购买',
        'selectMoney':'请选择购买金额',
      'onlineBuy':'购买',
      'please':'请',
      'dan':'单',
      'NO':'号',
      'tips':'该时间段已过或预约取餐人数已满，为免耽误用餐时间，请提前预约！',
      'deliverTime':'估计送达时间为'
    },
    cart: {
        'chosen': '已选',
        'cart': '购物车'
    },
	stores:{
		'existing':'已为你优选以下门店',
		'theCurrent':'当前城市暂未开通服务，目前已开通以下门店',
		'browse':'上次浏览'
	}
}



// WEBPACK FOOTER //
// ./src/assets/i18n/cn.js